export enum CapabilityTabNames {
  SLO = 'slo',
  HISTORY = 'history',
}
